const BUSINESS_TYPE = {
  PERSONAL: 'personal',
}

const TOP_TYPE = {
  upfront: 1,
  half: 2,
  settlement: 3,
}

export { BUSINESS_TYPE, TOP_TYPE }
